import React from "react";
import {
  Box,
  Container,
  Stack,
  SxProps,
  Typography,
  useTheme,
} from "@mui/material";
import { subtitleAnimations, titleAnimations } from "utils/sharedAnimations";
import { CustomAnimation } from "@thekilroygroup/shared-ui";

interface IProps {
  title?: string;
  subTitle?: string;
  bodyText?: string;
  children?: JSX.Element;
}

export const GraphicMessage = (props: IProps) => {
  const { title, subTitle, bodyText, children } = props;
  const theme = useTheme();
  return (
    <Container>
      <CustomAnimation type="grow" in timeout={300}>
        <Stack
          sx={{ minHeight: 0.7, width: 1, mt: 3 }}
          alignItems="center"
          justifyContent="center"
        >
          <Stack
            sx={{
              mt: { sm: 3, md: 4, lg: 5, xl: 6 },
              maxWidth: { sm: "400px", md: "450px", lg: "475px", xl: "500px" },
              width: `calc( 100% - ${theme.spacing(3)} )`,
              transition: `all ${theme.transitions.duration.complex}ms ${theme.transitions.easing.easeInOut}`,
              textAlign: "center",
            }}
            alignItems={"center"}
          >
            {title && (
              <CustomAnimation {...titleAnimations} in={true}>
                <Typography variant="h1" color="primary">
                  {title}
                </Typography>
              </CustomAnimation>
            )}
            {subTitle && (
              <CustomAnimation {...subtitleAnimations} in={true}>
                <Typography variant="h6">{subTitle}</Typography>
              </CustomAnimation>
            )}
            {bodyText && (
              <CustomAnimation {...subtitleAnimations} in={true}>
                <Typography variant="bodyMedium">{bodyText}</Typography>
              </CustomAnimation>
            )}
            <Box
              sx={{
                width: 0.75,
                maxWidth: 0.75,
                m: "auto",
                mt: { lg: 1, xl: 2 },
              }}
            >
              {children}
            </Box>
          </Stack>
        </Stack>
      </CustomAnimation>
    </Container>
  );
};
